/**
 * 본사/지사 캐시 내역 (/adm/gisa/cash)
 * ($j.Pages.Admin.GisaCash / body data-page-name="GisaCash")
 */
export default class GisaCash {
    initialize() {
        let $table = null;
        const today = dayjs();
        const twoDaysAgo = today.subtract(2, 'day');

        $('#start_date').val(twoDaysAgo.format('YYYY-MM-DD'));
        $('#end_date').val(today.format('YYYY-MM-DD'));

        // 검색 버튼
        $('#searchBtn').click(function () {
            $table.ajax.reload();
        });

        // 엑셀 버튼 — 현재 탭에서 다운로드 (다른 /excel/* 페이지와 동일 패턴)
        $('#excelBtn').on('click', function () {
            location.href = '/excel/gisa/cash';
        });

        // 페이지 길이 변경
        $('#page_length').change(function () {
            $table.page.len($(this).val()).draw();
        });

        // 날짜 피커
        $('#start_date, #end_date').mobiscroll().datepicker({
            controls: ['calendar'],
            dateFormat: 'YYYY-MM-DD',
            locale: mobiscroll.localeKo,
            buttons: [],
        });

        // 본사/지사 셀렉트 핸들러
        $j.Common.Form.registerBonsaHandler('ref-bonsa', 'ref-gisa', 'ref-center');
        $j.Common.Form.registerGisaHandler('ref-gisa', 'ref-center');
        $j.Common.Form.updateBonsaSelectBox('', 'ref-bonsa', 'ref-gisa', 'ref-center');

        // 엔터키 검색
        $('#ordernum').on('keydown', function (e) {
            if (e.key === 'Enter') {
                e.preventDefault();
                $('#searchBtn').click();
            }
        });

        /**
         * sosok_code 값 결정: 지사 선택 > 본사 선택 > 빈값
         */
        function getSosokCode() {
            var gisa = $('#ref-gisa').val();
            if (gisa) return gisa;
            return $('#ref-bonsa').val() || '';
        }

        $(function () {
            loadTable();
        });

        function loadTable() {
            const formatNumber = (number) => {
                return number ? number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") : '';
            };

            const columns = [
                {data: 'num', title: 'NO'},
                {data: 'datetime', title: '일시', render: v => $j.Common.Util.formatDateTime(v)},
                {data: 'work_time', title: '작업일시', render: v => $j.Common.Util.formatDateTime(v)},
                {data: 'ordernum', title: '오더번호'},
                {
                    data: 'car_price',
                    title: '오더금액',
                    render: function (data) { return formatNumber(data); }
                },
                {data: 'gisa_name', title: '지사'},
                {data: 'd_name', title: '본사'},
                {data: 'baljoo', title: '발주자',
                    render: (v, t, r) => parseInt(r.order_owner_num) ? $j.F.Admin.Member.Pop.cell(r.order_owner_num, r.bal_owner_name) + ` [${r.bal_rate}%]` : (v || '')},
                {data: 'soojoo', title: '수주자',
                    render: (v, t, r) => parseInt(r.worker_owner_num) ? $j.F.Admin.Member.Pop.cell(r.worker_owner_num, r.owner_name) + ` [${r.soo_rate}%]` : (v || '')},
                {
                    data: 'point',
                    title: '금액',
                    render: function (data) { return formatNumber(data); }
                },
                {
                    data: 'total_point',
                    title: '통장포인트',
                    render: function (data) { return formatNumber(data); }
                }
            ];

            if ($table) {
                $table.destroy();
                $('#gisa-cash-table').empty();
            }

            $table = new DataTable('#gisa-cash-table', {
                autoWidth: false,
                columns: columns,
                scrollY: 'calc(100vh / var(--adm-zoom, 1) - 230px)',
                scrollCollapse: true,
                scrollX: true,
                headerCallback: (thead) => $(thead).find('th').css('text-align', 'center'),
                columnDefs: [
                    {targets: 0, width: '60px'},
                    {targets: 1, width: '140px'},
                    {targets: 2, width: '130px'},
                    {targets: 3, width: '80px'},
                    {targets: 4, width: '100px'},
                    {targets: 5, width: '80px'},
                    {targets: 6, width: '80px'},
                    {targets: 7, width: '120px'},
                    {targets: 8, width: '120px'},
                    {targets: 9, width: '100px'},
                    {targets: 10, width: '100px'}
                ],
                rowCallback: formatRow,
                ajax: {
                    url: '/adm/ajax/gisa/cash/list',
                    type: 'post',
                    data: function (d) {
                        d.start_date = $('#start_date').val();
                        d.end_date = $('#end_date').val();
                        d.ordernum = $('#ordernum').val();
                        d.sosok_code = getSosokCode();
                    }
                },
                // 건수(info)는 여기서 정하지 않는다 — 전역 기본값($j.F.Admin.TableConfig)이
                // 관리자 표 공통 문구로 채운다. 예전엔 셋을 빈 문자열로 덮어 하단 좌측이 비어 있었다.
                language: {
                    emptyTable: "데이터가 없습니다.",
                    lengthMenu: "_MENU_ 개씩 보기",
                    loadingRecords: "로딩 중...",
                    zeroRecords: "일치하는 결과가 없습니다.",
                    paginate: {
                        previous: "<i class='fa fa-chevron-left'></i>",
                        next: "<i class='fa fa-chevron-right'></i>"
                    }
                },
                processing: true,
                serverSide: true,
                ordering: false,
                pageLength: 100,
                lengthChange: false,
                searching: false
            });
        }

        function formatRow(row, data) {
            // 작업일시 - 볼드
            $(row).find('td:nth-child(3)').css('font-weight', 'bold');

            // 오더번호 - 빨간 볼드
            $(row).find('td:nth-child(4)').css({color: 'var(--adm-kw-red, red)', fontWeight: 'bold'});

            // 오더금액 - 우측 정렬
            $(row).find('td:nth-child(5)').css('text-align', 'right');

            // 금액 컬럼 - 색상 분기 + 배경
            const pointCell = $(row).find('td:nth-child(10)');
            pointCell.css({'text-align': 'right', 'font-weight': 'bold', 'background-color': '#80FFFF'});
            const pointValue = parseInt(data.point, 10);
            if (pointValue > 0) {
                pointCell.css('color', 'var(--adm-kw-blue, blue)');
            } else if (pointValue < 0) {
                pointCell.css('color', 'var(--adm-kw-red, red)');
            }

            // 통장포인트 - 우측 정렬
            $(row).find('td:nth-child(11)').css('text-align', 'right');

            // 전체 중앙 정렬 (기본)
            $(row).find('td').each(function () {
                const td = $(this);
                const textAlign = td.css('text-align');
                if (!textAlign || textAlign === 'left') {
                    td.css('text-align', 'center');
                }
            });
        }
    }
}
